import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { Healthcareservice, HealthcareserviceSpecialists } from 'app/core/interfaces/healthcareservice';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { PatientScheduleRegistrationComponent } from 'app/modules/patient/pages/schedule/registration/schedule-registration.component';
import { firstValueFrom } from 'rxjs';
import { BaseComponent } from '../base.component';
import { Location } from 'app/core/interfaces/location';
import { ScheduleSelectPatientComponent } from '../schedule-select-patient/schedule-select-patient.component';

@Component({
  selector: 'schedule-specialist-card',
  templateUrl: './schedule-specialist-card.component.html',
  styleUrls: ['./schedule-specialist-card.component.css']
})
export class ScheduleSpecialistCardComponent extends BaseComponent {

  @Input() healthcareservicesSpecialist !: HealthcareserviceSpecialists;
  @Input() location !: Location;
  @Input() index: number = 0;
  @Input() practitioner?: Practitioner
  @Input() practitionerRole?: any

  @Input() dealer !: string;

  public byOrderStart: string = ''

  public healthcaservice?: Healthcareservice
  @Input() actor !: 'SECRETARY' | 'PATIENT'

  public selectedDatetime !: string;
  public patientLogged !: {
    user_id: string;
    name: string;
    email: string
    birthDate: string
  }

  public secretaryLogged !: {
    user_id: string;
    name: string;
    email: string
    birthDate: string
  }

  public isByOrder: boolean = false



  constructor(
    private healthcareserviceService: ProcedureService,
    private locationService: OrganizationLocationService,
    public injector: Injector
  ) {
    super(injector)
  }

  async ngOnInit() {

    const userLogged = this.getUserLogged();

    if (this.actor == 'SECRETARY') {
      this.secretaryLogged = {
        user_id: userLogged.id,
        name: userLogged.name,
        email: userLogged?.email,
        birthDate: userLogged.birthDate
      };
    }

    if (this.actor == 'PATIENT') {
      this.patientLogged = {
        user_id: userLogged.id,
        name: userLogged.name,
        email: userLogged?.email,
        birthDate: userLogged.birthDate
      };
    }


    this.healthcaservice = await this.getHealthcareService(this.healthcareservicesSpecialist.healthcareservice_id)

  }


  async getHealthcareService(healthcareservice_id: string): Promise<any> {
    return firstValueFrom(this.healthcareserviceService.show(healthcareservice_id));
  }

  getHealthcarePrice(healthcareservice: Healthcareservice) {
    if (!healthcareservice) return null;
    return `R$${healthcareservice?.price_high}`;
  }



  onSelectedDatetime(event: any, healthcareservice: any) {
    this.selectedDatetime = event.datetime;
    this.isByOrder = event.isByOrder
    this.byOrderStart = event.starthour


    if (this.actor == 'SECRETARY') {
      this.openSelectPatientRegistrationForm(healthcareservice)
    } else {
      this.openEncounterRegistrationForm(healthcareservice);
    }

  }

  async openEncounterRegistrationForm(healthcareserviceSpecialist: any) {
    try {
      const healthcareServiceDetails = this.healthcaservice


      const practitioner = {
        name: healthcareserviceSpecialist.practitioner_name,
        practitioner_id: healthcareserviceSpecialist.practitioner_id,
      };

      const procedureAdapter = {
        ...healthcareServiceDetails,
        name: healthcareserviceSpecialist.healthcareservice_name,
        healthcareservice_id: healthcareserviceSpecialist.healthcareservice_id,
        organization: {
          organization_id: healthcareserviceSpecialist.organization_id,
          name: healthcareserviceSpecialist.organization_name,
        },
      };


      const data = {
        title: 'Agendar consulta',
        param: {
          procedure: procedureAdapter,
          type: procedureAdapter.serviceType,
          address: this.location,
          patient: this.patientLogged,
          practitioner: practitioner,
          isByOrder: this.isByOrder,
          datetime: this.selectedDatetime,
          byOrderStart: this.byOrderStart,
        },
      };

      this.dialog.openComponentDialog(PatientScheduleRegistrationComponent, data, {
        width: '800px',
        height: '600px',
      }).subscribe((res: any) => {


        this.dialog.close()

      });


    } catch (error) {
      console.error('Erro ao buscar HealthcareService:', error);
    }
  }

  async openSelectPatientRegistrationForm(healthcareservice: any) {
    try {
      const healthcareServiceDetails = this.healthcaservice

      const practitioner = {
        name: healthcareservice.practitioner_name,
        practitioner_id: healthcareservice.practitioner_id,
      };

      const procedureAdapter = {
        ...healthcareServiceDetails,
        name: healthcareservice.healthcareservice_name,
        healthcareservice_id: healthcareservice.healthcareservice_id,
        organization: {
          organization_id: healthcareservice.organization_id,
          name: healthcareservice.organization_name,
        },
      };


      const data = {
        title: 'Agendar consulta',
        param: {
          procedure: procedureAdapter,
          type: procedureAdapter.type,
          address: this.location,
          secretary: this.secretaryLogged,
          practitioner: practitioner,
          isByOrder: this.isByOrder,
          datetime: this.selectedDatetime,
          byOrderStart: this.byOrderStart,

        },
      };



      this.dialog.openComponentDialog(ScheduleSelectPatientComponent, data, {
        width: '760px',
        maxWidth: '92vw',
        maxHeight: '90vh',
      }).subscribe((res: any) => {


        this.dialog.close()

      });


    } catch (error) {
      console.error('Erro ao buscar HealthcareService:', error);
    }
  }





}
